const TIME_ZONE = "America/Fortaleza";
const OFFSET = "-03:00";
const HOUR = 60 * 60 * 1000;

const inputFormat = new Intl.DateTimeFormat("en-GB", {
  timeZone: TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

const displayFormat = new Intl.DateTimeFormat("pt-BR", {
  timeZone: TIME_ZONE,
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

export function toInputValue(date: Date): string {
  const parts: { [type: string]: string } = {};
  inputFormat.formatToParts(date).forEach((part) => {
    parts[part.type] = part.value;
  });
  const hour = parts.hour === "24" ? "00" : parts.hour;

  return `${parts.year}-${parts.month}-${parts.day}T${hour}:${parts.minute}`;
}

export function isoToInputValue(iso: string): string {
  return toInputValue(new Date(iso));
}

export function inputValueToIso(value: string): string {
  return value ? `${value}:00${OFFSET}` : "";
}

export function formatDateTime(iso: string): string {
  return displayFormat.format(new Date(iso)).replace(",", "");
}

export function defaultPeriod(): { startsAt: string; endsAt: string } {
  const start = new Date(Math.ceil(Date.now() / HOUR) * HOUR);

  return {
    startsAt: toInputValue(start),
    endsAt: toInputValue(new Date(start.getTime() + HOUR)),
  };
}
